import React, { useMemo } from "react";
import { Grid, Box, Card, CardContent, Dialog, Fab } from "@mui/material";
import PlotComponent from "../plot/plot";
import CloseIcon from "@mui/icons-material/Close";

const SubPlot = React.memo(({ data, index }) => {
  const parsedData = useMemo(() => {
    if (!data?.plot_data || typeof data.plot_data !== "string") return {};
    try {
      return JSON.parse(data.plot_data);
    } catch {
      return {};
    }
  }, [data]);

  const titles = useMemo(() => data?.titles || {}, [data]);

  return (
    <Card
      elevation={3}
      sx={{
        mb: 1,
        borderRadius: 2,
        overflow: "hidden",
        border: "1px solid #e0e0e0",
        backgroundColor: "#fff",
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <PlotComponent
          plotKey={index}
          data={parsedData?.data}
          layout={{
            ...parsedData?.layout,
            height: parsedData?.layout?.height || 320,
            autosize: true,
          }}
          config={parsedData?.config}
          plotTitles={titles}
        />
      </CardContent>
    </Card>
  );
});

const SubPlotWrapper = React.memo(({ data, setOpen, open }) => {
  const dataEntries = useMemo(() => Object.entries(data || {}), [data]);

  // Precompute all parsed data and titles for Dialog grid
  const parsedPlots = useMemo(
    () =>
      dataEntries.map(([key, subData]) => ({
        key,
        parsed:
          subData?.plot_data && typeof subData.plot_data === "string"
            ? (() => {
                try {
                  return JSON.parse(subData.plot_data);
                } catch {
                  return {};
                }
              })()
            : {},
        titles: { main_title: subData?.titles?.main_title ?? "" },
      })),
    [dataEntries]
  );

  return (
    <Box sx={{ pt: 1 }}>
      {dataEntries.map(([key, subData], index) => (
        <SubPlot key={key} data={subData} index={index} />
      ))}

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullScreen
        PaperProps={{ sx: { bgcolor: "#fff", position: "relative" } }}
      >
        <Box sx={{ p: 1 }}>
          <Grid container spacing={0}>
            {parsedPlots.map(({ key, parsed, titles }, index) => (
              <Grid item xs={12} sm={6} md={4} lg={4} key={key}>
                <Card sx={{ border: "1px solid #e0e0e0" }}>
                  <CardContent sx={{ p: "0px 0px 24px 0px !important" }}>
                    <PlotComponent
                      plotKey={index}
                      data={parsed?.data}
                      layout={{
                        ...parsed?.layout,
                        height: parsed?.layout?.height || 260,
                        autosize: true,
                      }}
                      config={parsed?.config}
                      plotTitles={titles}
                      fullHeightProps={false}
                    />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Fab
          color="default"
          size="medium"
          onClick={() => setOpen(false)}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            backgroundColor: "rgba(206, 206, 206, 0.82)",
            border: "1px solid #ddd",
            boxShadow: 3,
            "&:hover": { backgroundColor: "#fff", transform: "scale(1.1)" },
            transition: "all 0.2s ease",
          }}
        >
          <CloseIcon />
        </Fab>
      </Dialog>
    </Box>
  );
});

export default SubPlotWrapper;
